const VerMasIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="8" width="18" height="2" fill="#A6A6A6" />
      <rect
        x="10"
        width="18"
        height="2"
        transform="rotate(90 10 0)"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default VerMasIcon;
